import { useState, useCallback } from 'react';

/**
 * Hook to handle pagination logic
 * Manages: Index tracking, next/prev navigation, page size
 */
export function usePagination({ pageSize = 8 } = {}) {
  const [index, setIndex] = useState(0);

  const handleNext = useCallback((allExperts, onLoadMore) => {
    const next = index + pageSize;

    if (next < allExperts.length) {
      setIndex(next);
      return { newIndex: next, needsLoadMore: false };
    } else {
      // Need to load more
      if (onLoadMore) {
        onLoadMore();
      }
      setIndex(prev => prev + pageSize);
      return { newIndex: next, needsLoadMore: true };
    }
  }, [index, pageSize]);

  const handlePrev = useCallback(() => {
    const prev = Math.max(index - pageSize, 0);
    setIndex(prev);
    return prev;
  }, [index, pageSize]);

  const resetIndex = useCallback(() => {
    setIndex(0);
  }, []);

  return {
    index,
    setIndex,
    handleNext,
    handlePrev,
    resetIndex,
    pageSize,
  };
}
